import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ComponentWithChildren } from '../../models/models';


const Section: React.FC<ComponentWithChildren> = ({children}) => {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};

const useStyles = makeStyles({
  root: {
    paddingBottom: '80px',
    width: '100%'
  }
}, { name: 'Mui-Section' });

export default Section;